export default {
  files: [],
  dialogState: false,
  directories: '',
}
